import React from 'react'
import PropTypes from 'prop-types'

import { Image } from 'semantic-ui-react'

// srcset="medium.jpg 1000w, large.jpg 2000w"

const ResponsiveImage = ({src, alt}) => {
  const l = src.length
  // const fileType = src.substr(-4, 4)
  // const suffix = src.substr(-12, 8)
  const prefix = src.substr(0, l - 12)
  // console.log(prefix + ' *** ' + suffix + ' *** ' + fileType)

  let srcset = ''
  const preprefix = prefix.substr(0, 39)
  // console.log(preprefix)

  if (preprefix === '/assets/photos/accenture/accenture_dock') {
    srcset = `${prefix}_800x800.jpg 800w, ${prefix}_400x400.jpg 400w, ${prefix}_200x200.jpg 200w`
  }
  // console.log('srcset >> ' + srcset)

  return (
    <Image
      srcSet={srcset}
      src={src}
      alt={alt}
    />
  )
}

ResponsiveImage.defaultProps = {
  src: '',
  alt: '',
}

ResponsiveImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
}

export default ResponsiveImage



// WEBPACK FOOTER //
// ./src/components/ResponsiveImage.js